import * as TimeUtils from '@acceligentllc/shared/utils/time';

import { TimeFormat } from '@acceligentllc/shared/enums/timeFormat';

import type { GlyphItem } from 'af-components/RHFTableCellComponents/Input/Glyph';

export function createValidFromGlyph(validFrom: string): GlyphItem {
	return {
		type: 'icon',
		value: 'calendar_warning',
		tooltip: `Valid from ${TimeUtils.formatDate(validFrom, TimeFormat.DATE_ONLY, TimeFormat.DB_DATE_ONLY)}`,
	};
}
